/**
 * @file useFileSyncAccess.ts
 * @description Whether this reader may see Syncretic File Sync at all. The
 * single place the capability is decided; consumers are the five hosts that
 * mount a file-sync surface — `FormControl`, `RecordDetailPanel`, `Attachments`,
 * `AttachmentList`, and `buildSettingsNavSections`, which reads the same right
 * off its `userRights` argument because it is a plain function, not a component.
 *
 * The hosts hide their surfaces rather than disabling them, the one deliberate
 * exception to the project's disable-don't-hide rule: File Sync is unreleased,
 * so a disabled control would advertise a capability nobody can obtain. Gating
 * at the host is also what keeps `useDesktopPins`, `useHeldAttachmentPushes` and
 * the rest from opening a listener for a reader without the right.
 *
 * It reads false while `users/{uid}` is still unread — the default context
 * carries `userRights: {}` — so the surfaces appear once, not flicker.
 */

import { useContext } from 'react';

import { UserContext } from '../../providers/UserContext';

export const useFileSyncAccess = (): boolean => {
    const { userRights } = useContext(UserContext);
    return !!userRights.fileSync;
};
